Buyapowa.Views.EmailShareManual = class EmailShareManual {
  constructor(el) {
    this.el = el;
    this.personalMessageEl = this.el.find("*[data-personal-message]");
    this.sendButtonEl = this.el.find("*[data-send-button]");
    this.personalSubjectEl = this.el.find("*[data-subject]");
    this.shareUrlEl = this.el.find("*[data-share-url-text]");

    new Buyapowa.Helpers.ManualEmailShare(this.el, this.sendButtonEl, this.personalMessageEl, this.personalSubjectEl, this.shareUrlEl);
  }
};
